<template>
  <modal
    :name="$lang.messages.addCardModal"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
  >

    <modals-header
      :modalNameProp="$lang.messages.addCardModal"
      @hideModalProp="hideAddCardModal"
    >
    </modals-header>

    <div class="fp-modal braintree-modal">
      
      <div class="braintree-modal-container">
        <div v-show="token === ''" class="spinner-container">
          <ClipLoader :loading="token === ''" :color="'#6A6969'" :size="'75px'"></ClipLoader>
        </div>
        <div id="dropin-container" :class="{'not-ff-browser': !isFirefox}"></div>
      </div>
    <div class="part" v-if="subscriptionActivated==='current' && allowReferralCode">
    <p class="input-filter-label">
      {{$lang.messages.optionalReferralCode}}
      
      <slot />
      
    </p>
    <div
      class="input-wrapper input-field"
       :class="{'error-input' : referralCodeError}"
    >
      <input
        :value="referralCode"
        @input="updateReferralCode"
        type="text"
        class="input"
        @focus="setBluredProp(true)"
        @blur="setBluredProp(false)"
        :placeholder=$lang.messages.optionalReferralCodePlaceholder
      />
      <img v-if="referralCodeError" src="@/assets/images/validation_ico.png" alt="" class="icon error-icon">
      
      <div
        v-show="referralCodeError"
        class="error-tooltip referral-error"
        :class="{'hide-tooltip': bluredProp}"
      >
        <div class="text">
          {{referralCodeError}}
        </div>
      </div>
    </div>
  </div>
      <div>
        <small>{{ $lang.messages.cardVerificationMessage1 }}</small>
        <br><br>
        <small>{{ $lang.messages.cardVerificationMessage2 }}</small>
        <br>
      </div>
      
      <div class="btn-wrapper">
        <button type="button" class="generic-btn" @click="hideAddCardModal">
          <span>{{ $lang.messages.back }}</span>
        </button>
        
        <button type="button" id="submit-button" class="action-btn" :disabled="!isBraintreeLoaded || loading">
          <span v-show="!loading">{{ $lang.messages.addCard }}</span>
          <ClipLoader :loading="loading" :color="'#fff'" :size="'20px'"></ClipLoader>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
  import { mapActions } from "vuex";
  import { GET_CLIENT_TOKEN,ADD_REFERRAL_CODE, BRAINTREE_ADD} from "@/store/action.types";
  import Loading from 'vue-loading-overlay';
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  import ClipLoader from 'vue-spinner/src/ClipLoader';
  import dropin from 'braintree-web-drop-in';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "addCard",
    components: {
      Loading,
      ClipLoader,
      'modals-header': modalsHeader
    },
    data() {
      return {
        token: '',
        bluredProp:false,
        subscriptionActivated:'',
        referralCodeError:"",
        allowReferralCode:false,
        referralCode:'',
        isFirefox: typeof InstallTrigger !== 'undefined',
        loading: false,
        isBraintreeLoaded: false
      }
    },
    methods: {
      ...mapActions({
        getClientTokenAction: GET_CLIENT_TOKEN,
        braintreeAddAction: BRAINTREE_ADD,
        addReferralCode:ADD_REFERRAL_CODE
      }),
      show(subscriptionActivated='',allowReferralCode=false) {
        this.clearAddCardData();
        this.getToken();
        this.clearReferralCodeData();
        this.subscriptionActivated = subscriptionActivated,
        this.allowReferralCode = allowReferralCode,
        this.$modal.show(this.$lang.messages.addCardModal);
      },
      hideAddCardModal() {
        this.$modal.hide(this.$lang.messages.addCardModal);
      },
      clearAddCardData() {
        this.token = '';
      },
      clearReferralCodeData(){
        this.referralCodeError ='';
        this.referralCode='';
      },
      setBluredProp(val){
        this.bluredProp=val;
      },
      updateReferralCode(e){
        this.referralCode = e.target.value; 
        if(this.referralCodeError){
          this.referralCodeError = '';
        }
      },
      getToken() {
        this.getClientTokenAction()
          .then(response => {
            this.token = response.data.data;
            if (this.token !== '') {
              this.startBraintree();
            }
          })
          .catch(error => {
            if (error.response.status !== 406 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          });
      },
      requestPaymentMethod(instance){
        instance.requestPaymentMethod(async(err, payload) =>{
          if (err) {
            this.loading = false;
            return
          }

          if (payload) {
            this.loading = false;
              this.hideAddCardModal();
              this.braintreeAddAction({nonce: payload.nonce})
              .then(() => {
                this.getRegistrationProgress();
              })
              .then(() => {
                this.$snotify.success(this.$lang.messages.sn_addCardSuccess, "SUCCESS");
                this.loadSubscriptions(true);
              })
              .catch(error => {
                if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
                  if(error.response.data && error.response.data.status && error.response.data.status.desc){
                    this.$snotify.error(error.response.data.status.desc, 'ERROR');
                  }
                  else
                    this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
                }
              });
          }
        });
      },
      startBraintree() {
        let clickEvent = new MouseEvent("click", {
          "view": window,
          "bubbles": true,
          "cancelable": true
        });

        dropin.create({
          authorization: this.token,
          container: '#dropin-container'
        })
          .then((instance) => {
            if (document.getElementsByClassName('braintree-card')[0] !== undefined) {
              this.isBraintreeLoaded = true;
            }
            // Triggers on Add Card Button
            setTimeout(() => document.getElementById('submit-button').addEventListener('click',async (e) => {
              if (!this.loading) {
                this.loading = true;
                if(this.referralCode){
                  this.addReferralCode({referralCode:this.referralCode})
                  .then(()=>{
                      this.requestPaymentMethod(instance);
                  })
                  .catch((error)=>{
                    this.loading = false;
                    if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
                          if(error.response.data && error.response.data.status && error.response.data.status.desc){
                            this.referralCodeError = error.response.data.status.desc;
                          }
                          else
                            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
                        }
                  })
                }
                else{
                  this.requestPaymentMethod(instance);
                }
              }
            }), 10);
          })
          .catch((e) => {
            //if a user closes the modal before the braintree dropin component is loaded the following error message returned here
            //we won't want the user to see a "something went wrong" message in case the user closes the modal before the braintree dropin is loaded
            if(e.message!=="options.selector or options.container must reference a valid DOM node.")
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          })
          .finally(() => {
            setTimeout(() => {
            const element = document.getElementsByClassName('braintree-toggle')[0];
             if(element){
               element.dispatchEvent(clickEvent);
             }
            }, 15);
          });
      },
      loadSubscriptions(setGotIt) {
        this.$emit("loadSubscriptions", setGotIt);
      },
      getRegistrationProgress() {
        this.$emit("getRegistrationProgress");
      },
    }
  };
</script>
